<template>
  <v-container>
    <h3 class="font-weight-bold">Ажилчдын бүртгэл</h3>
    <span v-if="userProfile">{{ userProfile.departmentName }} </span>
    <v-container id="regular-tables-view" tag="section"></v-container>
    <employee-table
      :item="{ name: title, fbpath: collectionName }"
      :allEmployees ="true"
    ></employee-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../firebaseConfig.js");

export default {
  data: () => ({
    stab: null,
    collectionName: "employees",
    title: "Багш, aжилтан",
  }),
  components: {
    EmployeeTable: () => import("@/views/teacher/EmployeeTable"),
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    yyschool(){
      return fb.yyschool
    }
  },
};
</script>
